module.exports = "/lucky-balls/img/drawnballs/yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/yellow.png
// module id = 1015
// module chunks = 0